import React, { useCallback, useEffect } from 'react'
import { Modal } from './Modal'

import '../assets/css/style.css'
import info from '../assets/img/icon/info.svg'
import { termsCookieValue } from './Simulation'
import { useDealerCodeUrl } from '../hook/useDealerCode'
import { useHistory } from 'react-router-dom'

interface SimulationTermsModalProps {
  isShow: boolean
  setShow: (isShow: boolean) => void
  setAgreeCookie: (value: string) => void
}

export const SimulationTermsModal: React.FC<SimulationTermsModalProps> = React.memo((props) => {
  const { isShow, setShow, setAgreeCookie } = props
  const history = useHistory()
  const topPath = useDealerCodeUrl('/')

  useEffect(() => {
    if (isShow) {
      document.body.setAttribute('style', 'overflow: hidden;')
    } else {
      document.body.removeAttribute('style')
    }

    return () => document.body.removeAttribute('style')
  }, [isShow])

  const handleAgree = useCallback(() => {
    setAgreeCookie(termsCookieValue.agree)
    setShow(false)
  }, [setAgreeCookie, setShow])

  const handleDisAgree = useCallback(() => {
    setAgreeCookie(termsCookieValue.disagree)
    document.body.removeAttribute('style')
    history.push(topPath)
  }, [history, setAgreeCookie, topPath])

  return (
    <React.Fragment>
      {isShow && (
        <Modal className={'c-modal'}>
          <div className="c-modal__content">
            <div className="c-modal__head">
              <span className="c-modal__head__icon">
                <img src={info} alt="" />
              </span>
              <h2 className="c-modal__head__title">将来シミュレーションのご利用にあたって</h2>
            </div>
            <div className="c-modal__body--terms">
              <p>
                本ツールは、過去のデータから算出された数値を用いて一定の仮定のもとに試算を行うものであり、手数料、税金等は考慮しておらず、実際の計算とは異なります。
                入力された取引と全く同様の取引を現実に行った場合でも、本ツールで表示される結果と現実の結果が一致しない場合があります。
              </p>
              <p>
                本ツールは、投資勧誘を目的とするものではなく、シミュレーション等に基づく参考表示による、
                情報提供を目的とするものであり、金融商品取引法に基づく開示書類ではありません。
              </p>
              <p>
                本ツールのいかなる内容も、将来の運用成果を示唆、予測あるいは保証するものではありません。
              </p>
              <p>
                本ツールは相当の注意をもって作成されましたが、野村アセットマネジメント（以下、「当社」）及び販売会社、その他情報提供者等が、
                その内容の正確性、完全性、信頼性、使用可能性、有用性及び適時性を保証するものではありません。
              </p>
              <p>
                お客さまは本ツールの利用に当たっては、シミュレーション等について、自己の責任で判断するものとします。
              </p>
              <p>
                投資判断、資産運用に際しては、必ず投資信託説明書（交付目論見書）を確認する等、お客さまの責任においてご判断ください。
              </p>
              <p>
                本ツールを参考とした・しないに関わらず、お客さまの投資損益等の資産運用の結果については、
                すべてお客さまに帰属し、当社及び販売会社、その他情報提供者等は一切責任を負わないものとします。
              </p>
              <p>
                お客さまの本ツールの利用、お客さまによる第三者の権利侵害に起因又は関連して紛争が生じた場合は、すべてお客さまの費用と責任で解決するものとします。
                また、当該紛争に関連して、当社及び販売会社、その他情報提供者等に費用が発生した場合又は賠償金等の支払いを行った場合については、
                利用者は当該費用及び賠償金等を負担するものとします。
              </p>
            </div>
            <div className="c-modal__button-wrap">
              <button className="c-modal__button" onClick={handleAgree}>
                同意します
              </button>
              <button className="c-modal__button" onClick={handleDisAgree}>
                同意しません
              </button>
            </div>
          </div>
          <div className="c-modal__overlay"></div>
        </Modal>
      )}
    </React.Fragment>
  )
})
